import { PropTypes } from 'prop-types';
import React, { useState } from 'react';
import { classnames } from 'tailwindcss-classnames';

import { getFormattedDate } from '../../../utils';
import Link from '../../Link';
import TitleLabel from '../../Titles/TitleLabel';

const CardTextBasedSmallHighlight = ({ date: _date, slug, tags, title }) => {
  const date = getFormattedDate(_date);
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className="relative h-full"
      onMouseEnter={() => {
        setHovered(true);
      }}
      onMouseLeave={() => {
        setHovered(false);
      }}
    >
      <div className="absolute inset-0 z-0 bg-ocean" />
      <div
        className="absolute inset-0 z-10 transition-all duration-500 ease-out bg-[#8ED9CF]"
        style={{ clipPath: `circle(${hovered ? `100%` : `30%`})` }}
      />
      <div className="relative z-20 flex flex-col h-full px-4 py-4 lg:py-5 lg:px-6 text-squid-ink">
        <TitleLabel color={classnames('text-squid-ink')} tags={tags} />
        <Link className="mt-2 lg:mt-4" to={`/article/${slug}`}>
          <h4 className="text-hover stink-h4">{title}</h4>
        </Link>

        {date && <p className="mt-auto stink-footnote">{date}</p>}
      </div>
    </div>
  );
};

CardTextBasedSmallHighlight.propTypes = {
  date: PropTypes.string,
  slug: PropTypes.string,
  tags: PropTypes.array,
  title: PropTypes.string,
};

export default CardTextBasedSmallHighlight;
